/**
 * Parse a color group
 *
 * @param {Array} items - the array of items
 * @returns {Array} the grouped items
 */
export default function parseColorGroup (items) {
  const groups = items.reduce((res, item) => {
    if (!item.groupType) {
      // No group type
      return res
    }

    if (!res[item.groupType]) {
      res[item.groupType] = []
    }

    res[item.groupType].push(item)

    return res
  }, {})

  const groupKeys = Object.keys(groups)

  if (!groupKeys.length) {
    // Failed to create groups
    return items
  }

  const res = Object.keys(groups).map((key, i) => {
    const firstItem = groups[key]?.[0]
    const createdBy = firstItem?.createdBy
    const brand = firstItem?.brand || {}

    return {
      id: `group-${i}`,
      groupIds: groups[key].map(group => group.id),
      createdBy,
      brand,
      colors: groups[key].reduce((res, group) => {
        res[group.color] = group
        res[group.color].groupId = `group-${i}`

        return res
      }, {})
    }
  })

  return res
}
